import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const Block =  ({  fieldsData, componentSourceOptions ,
    selectedPorts,
     setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Block:{
                    ...prevData.Block,
                    [key]: value
                }
            }
        })
    }

    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Block.component_source.value}
        condition={savedData.Block.condition}
        input={savedData.Block.input}
        name={savedData.Block.name}
        fieldsData={fieldsData}
    />)
}

export default Block;